<span
  class="bg-primary-50 text-primary-800 ml-2 inline-flex cursor-default items-center rounded-full px-2 py-0.5 text-xs"
>
  TEST
</span>
